export const Categories = {
  COLLECTIONS: "collections",
  TOKENS: "tokens",
};
